export default {
  verified: {
    id: 'product_page_verified',
    defaultMessage: 'Verified refurbished',
  },
  freeReturn: {
    id: 'product_reassurance_buttons_free_return',
    defaultMessage: '{day}-days free return',
  },
}
